import React from "react";
import { NavLink } from "react-router-dom";
import "../Footer.css";

export default function Footer() {
  return (
      <>
        {/* Reserved space for ads */}
        <div className="ad-space">
          {/* You can later place your Google AdSense script here */}
          <p></p>
        </div>

        <footer className="footer">
          <p className="text-sm text-gray-600">
            © {new Date().getFullYear()} JSONConverter.org All rights reserved.
          </p>
          <div className="footer-links">
            <NavLink to="/about-us">About Us</NavLink>
            <NavLink to="/contact-us">Contact Us</NavLink>
            <NavLink to="/faq">FAQ</NavLink>
            <NavLink to="/privacy-policy">Privacy Policy</NavLink>
            <NavLink to="/terms-of-service">Terms Of Service</NavLink>
          </div>
        </footer>
      </>
  );
}
